import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { faBook } from '@fortawesome/free-solid-svg-icons';
import { Maybe } from '@monorepo/shared/src/graph/schema-generated-types-educator';

type PageNumberProps = {
  pageNumber: Maybe<number> | undefined;
};

const PageNumber: React.FC<PageNumberProps> = ({ pageNumber }) => {
  const classes = useStyles();
  return (
    <div className={classes.pagination}>
      <FontAwesomeIcon icon={faBook} size={'lg'} />
      <span style={{ padding: '0 10px' }}>{`p.${pageNumber}`}</span>
    </div>
  );
};

export default PageNumber;

const useStyles = makeStyles((theme: Theme) => ({
  pagination: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: 'auto 1rem',
    ...theme.typography.subtitle1,
  },
}));
